const registerFocusRestoreDialog = (function () {
  if (!window.WeakMap || !window.MutationObserver) {
    return function () {};
  }
  const registered = new WeakMap();

  // store previous focused node centrally
  let previousFocus = null;
  document.addEventListener('focusout', (ev) => {
    previousFocus = ev.target;
  }, true);

  return function (dialog) {
    if (dialog.localName !== 'dialog') {
      throw new Error('Failed to upgrade focus on dialog: The element is not a dialog.');
    }
    if (registered.has(dialog)) { return; }
    registered.set(dialog, null);

    // replace showModal method directly, to save focus
    const realShowModal = dialog.showModal;
    dialog.showModal = function () {
      let savedFocus = document.activeElement;
      if (savedFocus === document || savedFocus === document.body) {
        // some browsers read activeElement as body
        savedFocus = previousFocus;
      }
      registered.set(dialog, savedFocus);
      realShowModal.call(this);
    };

    // watch for 'open' change and clear saved
    const mo = new MutationObserver(() => {
      if (!dialog.hasAttribute('open')) {
        registered.set(dialog, null);
      } else {
        // if open was cleared/set in the same frame, then the dialog will still be a modal (Y)
      }
    });
    mo.observe(dialog, { attributes: true, attributeFilter: ['open'] });

    // on close, try to focus saved, if possible
    dialog.addEventListener('close', () => {
      if (dialog.hasAttribute('open')) {
        return; // in native, this fires the frame later
      }
      let savedFocus = registered.get(dialog);
      if (document.contains(savedFocus)) {
        const wasFocus = document.activeElement;
        savedFocus.focus();
        if (document.activeElement !== savedFocus) {
          wasFocus.focus(); // restore focus, we couldn't focus saved
        }
      }
      savedFocus = null;
    });
  };
}());
export default registerFocusRestoreDialog;
